import List from "list.js";
import ObjectAssignPolyfill from "ObjectAssignPolyfill.js";
import $ from 'cash-dom';

const JobList = () => {
	ObjectAssignPolyfill();
	var listOptions = {
		valueNames: [
			{ data: ['branche'] },
			{ data: ['berufsgruppe'] },
			{ data: ['region'] }
		],
		page: 8,
		pagination: true
	};

	if (document.getElementsByClassName('filter-mask').length <= 0) {
		var mask = document.createElement('div');
		mask.classList.add('filter-mask');
		mask.style.display = 'none';
		mask.onclick = () => {
			this.style.display = 'none';
		};
		document.body.appendChild(mask);
	}

	// Return an array of the selected opion values
	// select is an HTML select element
	// see https://stackoverflow.com/questions/5866169/how-to-get-all-selected-values-of-a-multiple-select-box/5866331
	function getSelectValues(select) {
		var result = [];
		var options = select && select.options;
		var opt;

		for (var i=0, iLen=options.length; i<iLen; i++) {
			opt = options[i];

			if (opt.selected) {
				result.push(opt.value || opt.text);
			}
		}
		return result;
	}

	// filter function for items
	function itemMatchesFiltersClosure(filters) {
		return function itemMatchesFilters(item) {
			var values = item.values();
			let itemFilterMatchCount = 0;
			Object.keys(filters).forEach(key => {
				// The value '0' stands for all values
				if(filters[key].indexOf('0') != -1) {
					itemFilterMatchCount++;
					return;
				}
				// Each items matching filter entries are a comma-separated list
				var alLeastOneValueMatched = false;
				var itemMatchingKeys = values[key].split(',');
				itemMatchingKeys.forEach(itemMatchingKey => {
					if(filters[key].indexOf(itemMatchingKey) != -1) {
						alLeastOneValueMatched = true;
					}
				});
				if(alLeastOneValueMatched) {
					itemFilterMatchCount++;
				}

			});

			if (itemFilterMatchCount >= Object.keys(filters).length) {
				return true;
			}
		}
	}

	function filterList(jobList, filters) {
		// update filters
		Object.keys(filters).forEach(key => {
			filters[key] = window.choices[key].getValue(true);
		});

		// set filter
		let filterFn = itemMatchesFiltersClosure(filters);
		jobList.filter(filterFn);
	}

	function updateSession(selects) {
		let sessionFilter = {
			branche: [],
			berufsgruppe: [],
			region: [],
			language: 'de'
		};
		selects.forEach((currentSelect) => {
			sessionFilter[currentSelect.getAttribute('id')] = window.choices[currentSelect.getAttribute('id')].getValue(true);
		});
		if (document.getElementsByTagName('html') && document.getElementsByTagName('html')[0].hasAttribute('lang')) {
			sessionFilter['language'] = document.getElementsByTagName('html')[0].getAttribute('lang');
		}
		sessionStorage.setItem('ems-filter', JSON.stringify(sessionFilter));
	}

	Array.from(document.querySelectorAll('.load-from-sessionstorage-ems-filter')).forEach(item => {
		let emsFilter = sessionStorage.getItem('ems-filter');
		if (emsFilter) {
			item.value = emsFilter;
		}
	});

	function disableOptionsWithoutResults(select, filters, jobs) {
		let testFilters = JSON.parse(JSON.stringify(filters));

		let choices = window.choices[select.id].store.getChoices();
		choices.forEach(option => {
			testFilters[select.id] = [option.value || option.text];
			let hasResults = false;
			let filterFn = itemMatchesFiltersClosure(testFilters);
			jobs.forEach(item => {
				if(filterFn(item)) {
					hasResults = true;
				}
			});
			option.disabled = !hasResults;
			option.selected = false;
		});
		window.choices[select.id].setChoices(choices, 'value', 'label', true);

	}

	let tagIdUniqueCount = 0;

	Array.from(document.querySelectorAll('.job-list.layout-default')).forEach(item => {

		// if it doesn't has an id, create one
		// see https://github.com/javve/list.js/issues/592
		item.id = 'div_' + new Date().getTime().toString() + tagIdUniqueCount;
		tagIdUniqueCount++;

		let jobList = new List(item, listOptions);
		let filters = {};
		let selects = Array.from(item.querySelectorAll('.js-choice'));

		jobList.on('updated', function () {
			setTimeout(() => {
				let currentPage = document.querySelector('.job-list .pagination .active .page').text.trim();
				let totalPages = Math.ceil(jobList.items.length / jobList.page);
				if (currentPage > 1) {
					document.querySelector('.pagination-prev').style.visibility = 'visible';
				} else {
					document.querySelector('.pagination-prev').style.visibility = 'hidden';
				}
				if (currentPage < totalPages) {
					document.querySelector('.pagination-next').style.visibility = 'visible';
				} else {
					document.querySelector('.pagination-next').style.visibility = 'hidden';
				}
			}, 100);
		});
		document.querySelector('.job-list .pagination-prev').addEventListener('click', function (event) {
			document.querySelector('.job-list .pagination .active .page').parentElement.previousElementSibling.children[0].click();
			event.preventDefault();
			return false;
		});
		document.querySelector('.job-list .pagination-next').addEventListener('click', function (event) {
			document.querySelector('.job-list .pagination .active .page').parentElement.nextElementSibling.children[0].click();
			event.preventDefault();
			return false;
		});

		window.choices = [];
		Array.from(document.querySelectorAll('.js-choice')).forEach(choiceSelect => {
			window.choices[choiceSelect.id] = new Choices(choiceSelect, {
				removeItemButton: true,
				renderSelectedChoices: 'always',
				duplicateItems: false,
				itemSelectText: '',
				resetScrollPosition: false,
				placeholderValue: choiceSelect.getAttribute('data-name'),
				callbackOnCreateTemplates: function (template) {
					let classNames = this.config.classNames;
					return {
						item: (data) => {
							return template(`
								<div
									class="${classNames.item} ${data.highlighted ? classNames.highlightedState : classNames.itemSelectable}"
									data-item
									data-id="${data.id}"
									data-value="${data.value}"
									data-deletable
									${data.active ?
										'aria-selected="true"' :
										''
										}
									${data.disabled ?
										'aria-disabled="true"' :
										''
										}
									>
									<span class="checkbox checkbox--active" data-button aria-label="Remove item: '${data.value}'"></span>
									${data.label}
								</div>
							`);
						},
						choice: (data) => {
							let choiceIsActive = false;
							Array.from(this.getValue()).forEach(valueObj => {
								if(valueObj.value == data.value) {
									choiceIsActive = true;
								}
							});
							return template(`
								<div
									class="${classNames.item} ${classNames.itemChoice} ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable}"
									data-select-text="${this.config.itemSelectText}"
									data-choice
									data-id="${data.id}"
									data-value="${data.value}"
									${data.disabled ?
														'data-choice-disabled aria-disabled="true"' :
														'data-choice-selectable'
														}
									id="${data.elementId}"
									${data.groupId > 0 ?
														'role="treeitem"' :
														'role="option"'
														}
									>
									<span class="checkbox ${choiceIsActive ? 'checkbox--active' : ''}"></span><!--
									-->${data.label}
								</div>
							`);
						},
					};
				}
			});

			window.choices[choiceSelect.id].passedElement.addEventListener('choice', function(event) {
				let choiceIsActive = false;
				Array.from(window.choices[choiceSelect.id].getValue()).forEach(valueObj => {
					if(valueObj.value == event.detail.choice.value) {
						choiceIsActive = true;
					}
				});
				if (choiceIsActive) {
					setTimeout(() => {
						window.choices[choiceSelect.id].removeItemsByValue(event.detail.choice.value);

						// add "Alle" if needed
						if (window.choices[choiceSelect.id].getValue().length <= 0) {
							window.choices[choiceSelect.id].setValueByChoice('0');
						}
						filterList(jobList, filters);
					}, 10);
				} else {
					if (event.detail.choice.value == '0') {
						window.choices[choiceSelect.id].removeActiveItems();
						window.choices[choiceSelect.id].setValueByChoice('0');
						filterList(jobList, filters);
					}
				}
			}, false);

			window.choices[choiceSelect.id].passedElement.addEventListener('change', function(value) {
				let select = value.target;

				// remove "Alle" if no longer needed
				if (window.choices[select.id].getValue().length > 1) {
					window.choices[select.id].removeItemsByValue('0');
				}
				// add "Alle" if needed
				if (window.choices[select.id].getValue().length <= 0) {
					window.choices[select.id].setValueByChoice('0');
				}

				filterList(jobList, filters);
				updateSession(selects);
			}, false);

			window.choices[choiceSelect.id].passedElement.addEventListener('showDropdown', function(event) {
				let otherFilters = Object.assign({}, filters);
				delete otherFilters[this.id];
				disableOptionsWithoutResults(this, otherFilters, jobList.items);
				Array.from(document.getElementsByClassName('filter-mask')).forEach(filterMask => {
					filterMask.style.display = 'block';
				});
			}, false);

			window.choices[choiceSelect.id].passedElement.addEventListener('hideDropdown', function(event) {
				Array.from(document.getElementsByClassName('filter-mask')).forEach(filterMask => {
					filterMask.style.display = 'none';
				});
			}, false);

			filters[choiceSelect.id] = window.choices[choiceSelect.id].getValue().map(obj => {return obj.value;});
		});

		// initialize
		if (sessionStorage.getItem('ems-filter')) {
			let sessionFilters = JSON.parse(sessionStorage.getItem('ems-filter'));
			Object.keys(sessionFilters).forEach(sessionFilter => {
				if (sessionFilters[sessionFilter].length > 0) {
					window.choices[sessionFilter].removeActiveItems();
					Array.from(sessionFilters[sessionFilter], sessionFilterValue => {
						window.choices[sessionFilter].setValueByChoice(sessionFilterValue);
					});
				}
			});
		} else {
			updateSession(selects);
		}

		filterList(jobList, filters);

		selects.forEach(currentSelect => {
			disableOptionsWithoutResults(currentSelect, filters, jobList.matchingItems);
		});
	});

};

export default JobList;
